import { Component, Input } from "@angular/core";
import { Group } from "./group";

@Component({
    selector: "drag-and-drop-group-list",
    templateUrl: "./drag-and-drop-group-list.tmpl.html",
    standalone: false
})
export class DragAndDropGroupListComponent<T extends object = Record<string, unknown>>
{
    @Input() readonly input: Array<T>;
    // TODO - why do we have an @Input named `output`
    @Input() readonly output: Array<Group<T>>;
    @Input() readonly groupBy: keyof T;
    @Input() readonly displayProperty: keyof T;
    @Input() readonly sequenceProperty: keyof T;

    ngOnInit(): void
    {
        const grouped = this.input.reduce(
            (groups: Map<string, Group<T>>, value: T) =>
            {
                const groupValue = value[this.groupBy]?.toString();
                if (!groups.has(groupValue))
                {
                    groups.set(groupValue, {
                        Title: groupValue,
                        Items: [],
                    });
                }

                const g = groups.get(groupValue);
                g.Items.push(value);

                return groups;
            },
            new Map<string, Group<T>>());


        Array.from(grouped.values())
            .forEach((i: Group<T>) =>
            {
                if (!i.Items.length)
                {
                    return;
                }

                i.Items.sort((a: T, b: T) =>
                {
                    const aSequence = a[this.sequenceProperty];
                    const bSequence = b[this.sequenceProperty];
                    return aSequence < bSequence
                        ? -1
                        : 1;
                });

                this.output.push(i);
            });
    }
}
